import styled from 'styled-components'
export const AppSwrapper = styled.div`

height: 100vh;
width: 100vw;
display: flex;
justify-content: center;
align-items: center;

`